import { CreateElectionDto, UpdateElectionDto } from '@thro-clients/polyas-connector-api';

import { AxiosError, AxiosRequestConfig } from 'axios';
import { Gateway } from 'index';

export const getBulkUploadJobStatus = async (
  electionId: string,
  jobId: string,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await Gateway.get(
      `/polyas-connector/v1/elections/${electionId}/eligible-voters/bulk-upload/${jobId}`,
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getMyElections = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get(`/polyas-connector/v1/elections/my-elections`, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getMyElectionsCounts = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get(
      `/polyas-connector/v1/elections/my-elections/counts`,
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getAdminElections = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get(`/polyas-connector/v1/elections`, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getAdminElectionsCounts = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get(`/polyas-connector/v1/elections/meta/counts`, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getElectionById = async (electionId: string, config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get(`/polyas-connector/v1/elections/${electionId}`, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getElegibleVotersForElection = async (
  electionId: string,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await Gateway.get(
      `/polyas-connector/v1/elections/${electionId}/eligible-voters`,
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getElegibleVotersForElectionCount = async (
  electionId: string,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await Gateway.get(
      `/polyas-connector/v1/elections/${electionId}/eligible-voters/count`,
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getElegibleVotersForElectionFilter = async (
  electionId: string,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await Gateway.get(
      `/polyas-connector/v1/elections/${electionId}/eligible-voters/filter`,
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const createElection = async (
  createElection: CreateElectionDto,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await Gateway.post(`/polyas-connector/v1/elections`, createElection, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const updateElection = async (
  id: string,
  updateElection: UpdateElectionDto,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await Gateway.patch(
      `/polyas-connector/v1/elections/${id}`,
      updateElection,
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const setElectionVotingStatus = async (
  electionId: string,
  hasVoted: boolean,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await Gateway.patch(
      `/polyas-connector/v1/elections/${electionId}/eligible-voters/me/set-voting-status/${hasVoted}`,
      {},
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const uploadVoters = async (
  electionId: string,
  blob: FormData,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await Gateway.post(
      `/polyas-connector/v1/elections/${electionId}/eligible-voters/bulk-upload`,
      blob,
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const deleteElection = async (id: string, config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.delete(`/polyas-connector/v1/elections/${id}`, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const downloadVoters = (electionId: string) => {
  return `/polyas-connector/v1/elections/${electionId}/eligible-voters/export/polyas` as const;
};
